import { render, staticRenderFns } from "./IntroInfo.vue?vue&type=template&id=9335a4fa&"
import script from "./IntroInfo.vue?vue&type=script&lang=js&"
export * from "./IntroInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports